import React from "react";
import {
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  TableContainer,
  Table,
  Paper,
  TextField,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";

function RowsTable({ rows, total }) {
  return (
    <TableContainer component={Paper} style={{ width: "100%" }}>
      <Table size="small">
        <TableHead style={{ textTransform: "uppercase" }}>
          <TableRow>
            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
              Descripción
            </TableCell>
            <TableCell style={{ textAlign: "center", fontWeight: "bold" }}>
              Precio
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  required
                  label=""
                  variant="standard"
                  disabled
                  value={row.description}
                  style={{ width: "100%" }}
                  InputProps={{ disableUnderline: true }}
                />
              </TableCell>
              <TableCell>
                <TextField
                  required
                  label=""
                  variant="standard"
                  type="number"
                  disabled
                  value={row.price}
                  style={{ width: "100%" }}
                  InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                      <AttachMoneyIcon
                        style={{ fontSize: 16 }}
                      ></AttachMoneyIcon>
                    ),
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
          {/*Total Row*/}
          <TableRow>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              TOTAL
            </TableCell>
            <TableCell style={{ fontWeight: "bold", textAlign: "center" }}>
              ${total.toFixed(2)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RowsTable;
